var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconsMfaStep1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 96,
    viewBox: "0 0 128 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons-mfa-step1",
    transform: "translate(-1351 -359)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7660",
    "data-name": "Group 7660",
    transform: "translate(0 -77)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4034",
    "data-name": "Rectangle 4034",
    width: 119,
    height: 10,
    transform: "translate(1356 441)",
    fill: "#3d464c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4033",
    "data-name": "Rectangle 4033",
    transform: "translate(1351 436)",
    fill: "none",
    stroke: "#aaafb3",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 96,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 123,
    height: 91,
    rx: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4035",
    "data-name": "Rectangle 4035",
    transform: "translate(1368 467)",
    fill: "none",
    stroke: "#e3e5e6",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 95,
    height: 14,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 94.5,
    height: 13.5,
    rx: 1.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4036",
    "data-name": "Rectangle 4036",
    transform: "translate(1368 486)",
    fill: "none",
    stroke: "#e3e5e6",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 95,
    height: 14,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 94.5,
    height: 13.5,
    rx: 1.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4037",
    "data-name": "Rectangle 4037",
    width: 95,
    height: 12,
    rx: 2,
    transform: "translate(1368 506)",
    fill: "#0c9fed"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_53",
    "data-name": "Ellipse 53",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(1359 444)",
    fill: "#ed555a",
    opacity: 0.786
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_54",
    "data-name": "Ellipse 54",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(1365 444)",
    fill: "#f0a00c",
    opacity: 0.786
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_55",
    "data-name": "Ellipse 55",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(1371 444)",
    fill: "#64a340",
    opacity: 0.786
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14930",
    "data-name": "Path 14930",
    d: "M-7393.5-3813h37.9",
    transform: "translate(8769.234 4287)",
    fill: "none",
    stroke: "#e3e5e6",
    strokeLinecap: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14931",
    "data-name": "Path 14931",
    d: "M-7393.5-3813h61.569",
    transform: "translate(8769.234 4306)",
    fill: "none",
    stroke: "#e3e5e6",
    strokeLinecap: "round",
    strokeWidth: 5,
    strokeDasharray: "0 6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "kone_logo",
    transform: "translate(1407.892 433.183)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10845",
    "data-name": "Path 10845",
    d: "M1.5,29.585H4.025V24H1.5Zm5.55,0H9.575V24H7.05Zm-2.781,0H6.794V24H4.269ZM9.819,24v5.585h2.525V24Z",
    transform: "translate(0 0)",
    fill: "#0071b9"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsMfaStep1);
export default __webpack_public_path__ + "static/media/icons-mfa-step1.877c48d5.svg";
export { ForwardRef as ReactComponent };